import { AbstractControl, ValidationErrors } from '@angular/forms';

type AddressFields = 'Street' | 'HouseNumber' | 'PostalCode';

const AddressFieldSizeValidation: Record<AddressFields, number> = {
  Street: 64,
  HouseNumber: 12,
  PostalCode: 10,
};

const AddressFieldSizeViolation = (value: string, allowed: number): Record<string, unknown> => ({
  invalid: {
    value,
    cause: `Too many characters. Allowed: ${allowed}`,
  },
});

export class AddressValidators {
  public static street({ value }: AbstractControl): ValidationErrors | null {
    return AddressValidators.getViolations(value, AddressFieldSizeValidation.Street);
  }

  public static streetNumber({ value }: AbstractControl): ValidationErrors | null {
    return AddressValidators.getViolations(value, AddressFieldSizeValidation.HouseNumber);
  }

  public static postalCode({ value }: AbstractControl): ValidationErrors | null {
    return AddressValidators.getViolations(value, AddressFieldSizeValidation.PostalCode);
  }

  private static getViolations(value: string, validator: number): Record<string, unknown> | null {
    return value?.length > validator ? AddressFieldSizeViolation(value, validator) : null;
  }
}
